import React from 'react'
import { useMedia } from 'react-use'

import { SwiperImageSlider } from '../../../../../brunswick/components/SwiperImageSlider'
import { Kit } from '../../../../../types/graphql'
import { GalleryImageStateContainer } from '../../ProductPage/contexts/GalleryImageStateContainer'

export interface KitSwiperProps {
  kit: Kit
}

export const KitSwiper: React.FC<KitSwiperProps> = ({ kit }) => {
  const { allAssets, currentAssetIndex, showImageZoom } = GalleryImageStateContainer.useContainer()
  const shouldDisplayIconBadge = currentAssetIndex === 0
  const showExtraLargeIcon = useMedia(`(min-width: 1100px)`, false)

  const kitProduct = kit?.productGroup?.products[0]

  const iconBadge = kitProduct?.iconBadge ?? kit?.productGroup?.iconBadge
  const iconBadgePlacement = kitProduct?.iconBadgePlacement ?? kit?.productGroup?.iconBadgePlacement

  return (
    <SwiperImageSlider
      fitModelCaption={null}
      iconBadge={iconBadge}
      iconBadgePlacement={iconBadgePlacement}
      isKit
      shouldDisplayIconBadge={shouldDisplayIconBadge}
      showExtraLargeIcon={showExtraLargeIcon}
      showImageZoom={showImageZoom}
      sliderAssets={allAssets}
    />
  )
}
